import React from "react";
import { useParams } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ViewProfileLayer from "../components/ViewProfileLayer";

const ViewProfilePage = () => {
  const { userId } = useParams();

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="פרופיל תלמיד" />

        {/* ViewProfileLayer */}
        <ViewProfileLayer userId={userId} />
      </MasterLayout>
    </>
  );
};

export default ViewProfilePage; 
